import {
  Checkbox,
  IconButton,
  ListMenu,
  pn,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  UpdateIconButton,
} from "@compass/core";

import EventNoteIcon from "@mui/icons-material/EventNote";
import { ListBeProperty } from "components";
import { LkRoleId, Permission, PermissionAction, SortObject, StaffListDto, StaffListResource } from "generated/openApi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "redux/store";
import { isAuthorized } from "services";
import { useStaffListMenuItems } from "./useStaffListMenuItems";
import { staffPageRoute } from "../StaffPage/StaffPage";
import { staffServicePageRoute } from "pages/staff/staff-services/StaffServicePage/StaffServicePage";

export const StaffTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  staffs: StaffListDto[];
  listTotal: number | undefined;
  resource: StaffListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  selectId: (id: number) => void;
  selectedIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  getIdsPromise: () => Promise<any>;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];
  const menuItems = useStaffListMenuItems({ permission: props.rootPermission, selectedIds: props.selectedIds });
  const roleId = useSelector((state: RootState) => state.app.roleId);

  const view = (item: StaffListDto) => {
    if (roleId === LkRoleId.DataEntry) return undefined;
    return () => navigate(staffPageRoute.getPath({ id: item.id, crudMode: "view" }));
  };

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {menuItems.length > 0 && (
              <TableCell type="select">
                <ListMenu
                  selectedIds={props.selectedIds}
                  setSelectedIds={props.setSelectedIds}
                  listTotal={props.listTotal}
                  fetchFunction={() => props.getIdsPromise()}
                  actionMenuItems={menuItems}
                />
              </TableCell>
            )}

            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffListDto>("fullName"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            {/* <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffListDto>("identification"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffListDto>("discipline"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffListDto>("position"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell> */}
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffListDto>("currentSchool"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.staffs.map((staffItem) => (
            <TableRow key={staffItem.id} onClick={view(staffItem)}>
              {menuItems.length > 0 && (
                <TableCell type="select">
                  <Checkbox
                    checked={props.selectedIds.includes(staffItem.id)}
                    onClick={(e) => props.selectId(staffItem.id)}
                  />
                </TableCell>
              )}

              <TableCell>{staffItem.fullName}</TableCell>
              {/* <TableCell>{staffItem.identification}</TableCell>
              <TableCell>{staffItem.discipline}</TableCell>
              <TableCell>{staffItem.position}</TableCell> */}
              <TableCell>{staffItem.currentSchool}</TableCell>
              <TableCell type="action">
                {/* {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton
                    onClick={() => navigate(staffPageRoute.getPath({ id: staffItem.id, crudMode: "edit" }))}
                  />
                )} */}

                {isAuthorized(Permission.StaffService, PermissionAction.Create) && (
                  <IconButton
                    onClick={() =>
                      navigate({
                        pathname: staffServicePageRoute.getPath({ id: 0, crudMode: "edit", screenType: "dialog" }),
                        search: staffServicePageRoute.getOptionalParams?.({
                          hideStaff: true,
                          staffId: staffItem.id,
                        }),
                      })
                    }
                    color="primary"
                    size="small"
                  >
                    <Stack direction="row" alignItems="center">
                      <Typography variant="caption">+</Typography>
                      <EventNoteIcon />
                    </Stack>
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
